module.exports = __webpack_public_path__ + "static/media/warranty.a718bb63.svg";